import UIkit from '@node_modules/uikit';
import Icons from '@node_modules/uikit/dist/js/uikit-icons';

// loads the Icon plugin
UIkit.use(Icons);


require("./main.js");

require("../vendors/jquery-3.2.1.min.js");